import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import Analytics from './pages/Analytics/Analytics';
import ForgotPassword from './pages/Auth/ForgotPassword';
import SignIn from './pages/Auth/SignIn';
import SignUp from './pages/Auth/SignUp';
import AboutUs from './pages/Public/AboutUs';
import ContactUs from './pages/Public/ContactUs';
import Policies from './pages/Public/Policies';
import RefundPolicy from './pages/Public/RefundPolicy';
import TermsAndConditions from './pages/Public/TermsAndConditions';
import AddCar from './pages/CarManagement/AddCar';
import BulkUpload from './pages/CarManagement/BulkUpload';
import CarDetails from './pages/CarManagement/CarDetails';
import CarManagement from './pages/CarManagement/CarManagement';
import EditCar from './pages/CarManagement/EditCar';
import Dashboard from './pages/Dashboard/Dashboard';
import Enquiries from './pages/Enquiries/Enquiries';
import EnquiryDetails from './pages/Enquiries/EnquiryDetails';
import PaymentResult from './pages/Payments/PaymentResult';
import PriceSuggestion from './pages/PriceSuggestion/PriceSuggestion';
import Subscription from './pages/Subscription/Subscription';
import AddSeller from './pages/SellerManagement/AddSeller';
import SellerDetailPage from './pages/SellerManagement/SellerDetailPage';
import SellerManagement from './pages/SellerManagement/SellerManagement';
import Settings from './pages/Settings/Settings';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Auth routes - outside layout */}
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/contact" element={<ContactUs />} />

            {/* 1Pay redirects the browser here after processing the payment */}
            <Route path="/payment/result" element={<PaymentResult />} />

            {/* Redirect root to signin */}
            <Route path="/" element={<Navigate to="/signin" replace />} />
            
            {/* Protected routes - inside layout */}
            <Route path="/dashboard" element={
              <ProtectedRoute requiredRole="agent">
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="cars" element={<CarManagement />} />
              <Route path="cars/add" element={<AddCar />} />
              <Route path="cars/edit/:id" element={<EditCar />} />
              <Route path="cars/:id" element={<CarDetails />} />
              <Route path="cars/bulk-upload" element={<BulkUpload />} />
              <Route path="sellers" element={<SellerManagement />} />
              <Route path="sellers/add" element={<AddSeller />} />
              <Route path="sellers/:id" element={<SellerDetailPage />} />
              <Route path="subscribe" element={<Subscription />} />
              <Route path="enquiries" element={<Enquiries />} />
              <Route path="enquiries/:id" element={<EnquiryDetails />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="price-suggestion" element={<PriceSuggestion />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;